import { domToReact, HTMLReactParserOptions } from 'html-react-parser';

import CustomerReviews from '~components//CustomerReviews/CustomerReviews';
import Accordion from '~components/Accordion/Accordion';
import AccordionItem from '~components/Accordion/AccordionItem';
import AccordionMarketing from '~components/AccordionMarketing/AccordionMarketing';
import AccordionMarketingCard from '~components/AccordionMarketingCard/AccordionMarketingCard';
import AdobeABExperience from '~components/AdobeABTest/AdobeABExperience';
import AdobeABTest from '~components/AdobeABTest/AdobeABTest';
import { Phone, Hours } from '~components/AllianceCallService/AllianceCallService';
import PersonalCodeBanner from '~components/AllianceResponsive/PersonalCodeBanner/PersonalCodeBanner';
import PersonalCodeDisclaimer from '~components/AllianceResponsive/PersonalCodeDisclaimer/PersonalCodeDisclaimer';
import PersonalCodeHero from '~components/AllianceResponsive/PersonalCodeHero/PersonalCodeHero';
import AnswerCenterExplorer from '~components/AnswerCenterExplorer/AnswerCenterExplorer';
import BenefitsExplorer from '~components/BenefitsExplorer/BenefitsExplorer';
import Breadcrumb from '~components/Breadcrumb/Breadcrumb';
import Button from '~components/Button/Button';
import ButtonWithIcon from '~components/ButtonWithIcon/ButtonWithIcon';
import CallExpectations from '~components/CallExpectations/CallExpectations';
import CallOut from '~components/CallOut/CallOut';
import CardBeforeAfterEhealth from '~components/Card/CardBeforeAfterEhealth';
import CardBlogPost from '~components/Card/CardBlogPost';
import CardContainer from '~components/Card/CardContainer';
import CardWithIconAndBanner from '~components/Card/CardWithIconAndBanner';
import CardWithIconAndHiddenDescription from '~components/Card/CardWithIconAndHiddenDescription';
import Card from '~components/Card/CardWithMedallion';
import CardCarousel from '~components/CardCarousel/SlidingPageCarousel';
import CarrierLogosRibbon from '~components/CarrierLogos/CarrierLogosRibbon';
import ComparePlansValueProp from '~components/ComparePlansValueProp/ComparePlansValueProp';
import CompareToSaveValueProp from '~components/CompareToSaveValueProp/CompareToSaveValueProp';
import ComparisonTable from '~components/ComparisonTable/ComparisonTable';
import ConsumerReviews from '~components/ConsumerReviews/ConsumerReviews';
import CustomerCenter from '~components/CustomerCenter/BlockWrapper';
import DepthTracking from '~components/DepthTracking/DepthTracking';
import DiscoveryTab from '~components/DiscoveryTab/DiscoveryTab';
import DoctorTool from '~components/DoctorTool/DoctorTool';
import DropdownCta from '~components/DropdownCta/DropdownCta';
import EnrollOnlineFAQ from '~components/EnrollOnlineFAQ/EnrollOnlineFAQ';
import EnrollOnlineFAQItem from '~components/EnrollOnlineFAQ/EnrollOnlineFAQItem';
import FaqMarketing from '~components/FaqMarketing/FaqMarketing';
import FullWidthCta from '~components/FullWidthCta/FullWidthCta';
import GetMSGuide from '~components/GetMSGuide/GetMSGuide';
import Hero from '~components/Hero/Hero';
import HeroPaidSearch from '~components/HeroPaidSearch/HeroPaidSearch';
import HowItWorksRedesign from '~components/HowItWorks/HowItWorksRedesign';
import IconTextBlurb from '~components/IconTextBlurb/IconTextBlurb';
import IepInfographic from '~components/IepInfographic/IepInfographic';
import InlineTrackedLink from '~components/InlineTrackedLink/InlineTrackedLink';
import EnrollmentChecklist from '~components/LeadForm/EnrollmentChecklist/EnrollmentChecklist';
import LeadForm from '~components/LeadForm/LeadForm';
import EnrollmentReminder from '~components/LeadForm/NtmEnrollmentReminder/EnrollmentReminder';
import EnrollmentReminderModal from '~components/LeadForm/NtmEnrollmentReminder/EnrollmentReminderModal';
import LpChatScript from '~components/LpChatScript/LpChatTag';
import ManifestoVideo from '~components/ManifestoVideo/ManifestoVideo';
import MedicareChecklistDownloader from '~components/MedicareChecklistDownloader/MedicareChecklistDownloader';
import MedicareTool from '~components/MedicareTools/MedicareToolsButton';
import MidContentCta from '~components/MidContentCta/MidContentCta';
import PersonalCodeNeedHelp from '~components/NeedHelp/NeedHelpPreset';
import NewHero from '~components/NewHero/NewHero';
import NewToMedicareChecklist from '~components/NewToMedicareChecklist/NewToMedicareChecklist';
import NewToMedicareExplorer from '~components/NewToMedicareExplorer/NewToMedicareExplorer';
import NextBackButton from '~components/NextBackButton/NextBackButton';
import NtmGuideModal from '~components/NtmGuideModal/NtmGuideModal';
import { usePageContext } from '~components/PageDataProvider/PageDataProvider';
import PartnerDoctorWidget from '~components/PartnerDoctorWidget/PartnerDoctorWidget';
import PartnerZipLeadComboForm from '~components/PartnerZipLeadComboForm/PartnerZipLeadComboForm';
import FAQRedesign from '~components/PersonalCodeFAQ/FAQRedesign';
import PersonalizePlanReco from '~components/PersonalizePlanReco/PersonalizePlanReco';
import PlanRecommendationsValueProp from '~components/PlanRecommendationsValueProp/PlanRecommendationsValueProp';
import PlansComparisonTable from '~components/PlansComparisonTable/PlansComparisonTable';
import PopupCtaListener from '~components/PopupCta/PopupCtaListener';
import ReadingMinutes from '~components/ReadingMinutes/ReadingMinutes';
import RelatedArticlesExplorer from '~components/RelatedArticlesExplorer/RelatedArticlesExplorer';
import RetirablePerksOffer from '~components/RetirablePerksOffer/RetirablePerksOffer';
import SepBanner from '~components/SepBanner/SepBanner';
import SepDisclaimer from '~components/SepDisclaimer/SepDisclaimer';
import Share from '~components/Share/Share';
import SideBySide from '~components/SideBySide/SideBySide';
import Step from '~components/StepNavigation/Step';
import StepNavigation from '~components/StepNavigation/StepNavigation';
import StickyMedicareGuide from '~components/StickyMedicareGuideLeadForm/DismissableSticky';
import Summary from '~components/Summary/Summary';
import SutterReviewPlanOptions from '~components/SutterReviewPlanOptions/SutterReviewPlanOptions';
import ThreeWaysToShop from '~components/ThreeWaysToShop/ThreeWaysToShop';
import Tips from '~components/Tips/Tips';
import TopConsiderationsInfographic from '~components/TopConsiderationsInfographic/TopConsiderationsInfographic';
import TrustedPartnerValueProp from '~components/TrustedPartnerValueProp/TrustedPartnerValueProp';
import TrustpilotCardCarousel from '~components/Trustpilot/CardCarousel';
import TrustPilotBlock from '~components/Trustpilot/TrustPilotBlock';
import VideoEmbed from '~components/VideoEmbed/VideoEmbed';
import WayToShop from '~components/WayToShop/WayToShop';
import WhyEhealthValueProp from '~components/WhyEhealth/WhyEhealthValueProp';
import ZeroPremiumsValueProp from '~components/ZeroPremiumsValueProp/ZeroPremiumsValueProp';
import ZipForm from '~components/ZipCodeForm/BlockWrapper';
import Grid from '~components/_layout/Grid/Grid';
import GridColumn from '~components/_layout/GridColumn/GridColumn';
import MinimalFooter from '~components/_layout/MinimalFooter/MinimalFooter';
import StickyCtaBanner from '~components/_layout/StickyCtaBanner/StickyCtaBanner';
import { IExtendedDOMNode } from '~globals/interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const components: Record<string, React.JSXElementConstructor<any>> = {
    accordion: Accordion,
    accordionitem: AccordionItem,
    accordionmarketing: AccordionMarketing,
    accordionmarketingcard: AccordionMarketingCard,
    adobeabexperience: AdobeABExperience,
    adobeabtest: AdobeABTest,
    alliancepersonalcodebanner: PersonalCodeBanner,
    alliancepersonalcodefaq: FAQRedesign,
    alliancepersonalcodehero: PersonalCodeHero,
    alliancepersonalcodehowitworks: HowItWorksRedesign,
    alliancepersonalcodeneedhelp: PersonalCodeNeedHelp,
    answercenterexplorer: AnswerCenterExplorer,
    benefitsexplorer: BenefitsExplorer,
    breadcrumb: Breadcrumb,
    button: Button,
    buttonicon: ButtonWithIcon,
    callexpectations: CallExpectations,
    callout: CallOut,
    card: Card,
    cardbeforeafterehealth: CardBeforeAfterEhealth,
    cardblogpost: CardBlogPost,
    cardcarousel: CardCarousel,
    cardcontainer: CardContainer,
    cardwithiconandbanner: CardWithIconAndBanner,
    cardwithiconandhiddendescription: CardWithIconAndHiddenDescription,
    carrierlogosribbon: CarrierLogosRibbon,
    compareplansvalueprop: ComparePlansValueProp,
    comparetosavevalueprop: CompareToSaveValueProp,
    comparisontable: ComparisonTable,
    consumerreviews: ConsumerReviews,
    customercenter: CustomerCenter,
    customerreviews: CustomerReviews,
    custompopupcta: PopupCtaListener,
    depthtracking: DepthTracking,
    discoverytab: DiscoveryTab,
    doctortool: DoctorTool,
    partnerdoctorwidget: PartnerDoctorWidget,
    dropdowncta: DropdownCta,
    enrollmentchecklist: EnrollmentChecklist,
    enrollmentreminder: EnrollmentReminder,
    enrollmentremindermodal: EnrollmentReminderModal,
    enrollonlinefaq: EnrollOnlineFAQ,
    enrollonlinefaqitem: EnrollOnlineFAQItem,
    faqmarketing: FaqMarketing,
    fullwidthcta: FullWidthCta,
    grid: Grid,
    gridcolumn: GridColumn,
    herobanner: Hero,
    heropaidsearch: HeroPaidSearch,
    hours: Hours,
    icontextblurb: IconTextBlurb,
    iepinfographic: IepInfographic,
    inlinetrackedlink: InlineTrackedLink,
    leadform: LeadForm,
    lpchatscript: LpChatScript,
    manifestovideo: ManifestoVideo,
    medicarechecklistdownloader: MedicareChecklistDownloader,
    medicaretool: MedicareTool,
    midcontentcta: MidContentCta,
    minimalfooter: MinimalFooter,
    newhero: NewHero,
    newtomedicarechecklist: NewToMedicareChecklist,
    newtomedicareexplorer: NewToMedicareExplorer,
    nextbackbutton: NextBackButton,
    ntmguidemodalcta: NtmGuideModal,
    partnerzipleadcombo: PartnerZipLeadComboForm,
    phone: Phone,
    planrecommendationsvalueprop: PlanRecommendationsValueProp,
    planscomparisontable: PlansComparisonTable,
    readingminutes: ReadingMinutes,
    relatedarticlesexplorer: RelatedArticlesExplorer,
    sepbanner: SepBanner,
    sepdisclaimer: SepDisclaimer,
    share: Share,
    sidebyside: SideBySide,
    stickyctabanner: StickyCtaBanner,
    stickymedicareguide: StickyMedicareGuide,
    step: Step,
    stepnavigation: StepNavigation,
    summary: Summary,
    tips: Tips,
    topconsiderationsinfographic: TopConsiderationsInfographic,
    trustedpartnervalueprop: TrustedPartnerValueProp,
    trustpilot: TrustPilotBlock,
    trustpilotcarousel: TrustpilotCardCarousel,
    videoembed: VideoEmbed,
    waytoshop: WayToShop,
    whyehealthvalueprop: WhyEhealthValueProp,
    zeropremiumsvalueprop: ZeroPremiumsValueProp,
    zipform: ZipForm,
    threewaystoshop: ThreeWaysToShop,
    personalizeplanreco: PersonalizePlanReco,
    personalcodedisclaimer: PersonalCodeDisclaimer,
    retirableperksoffer: RetirablePerksOffer,
    sutterreviewplanoptions: SutterReviewPlanOptions,
    getmsguide: GetMSGuide,
};

const postContentBlock = (
    node: {
        children: IExtendedDOMNode[];
        name: string;
        attribs: Record<string, string | boolean>;
    },
    options: HTMLReactParserOptions
) => {
    const { children, name, attribs } = node;
    const ContentElement = components[name.split('-').slice(2).join('')];
    // filter out WP block specific classes
    const filteredClasses = (attribs.class as string)
        ?.split(' ')
        .filter((item) => !item.includes('wp-'))
        .join(' ');
    Object.assign(attribs, { classes: filteredClasses });
    // delete attribs.class;

    const costDataProps = usePageContext().annualCostData?.customProperties;

    Object.keys(attribs).forEach((key) => {
        // convert true/false string attribs to booleans
        if (attribs[key] === 'false') {
            attribs[key] = false;
        } else if (attribs[key] === 'true') {
            attribs[key] = true;
        }
        // replace annual cost data variables with real values, same as in post content but for ehealth blocks
        if (typeof attribs[key] === 'string') {
            const content = attribs[key] as string;
            if (costDataProps && Object.keys(costDataProps).length > 0) {
                Object.keys(costDataProps).forEach((prop) => {
                    if (content.includes(prop)) {
                        attribs[key] = content.replaceAll(`{{${prop}}}`, costDataProps[prop].value);
                    }
                });
            }
        }
    });

    // eject and handle inside other components
    if (
        name.split('-').slice(2).join('') === 'permanentlandingpagebanner' || // in Layout.tsx
        name === 'ehealth-block-answercenteritem' // in AnswerCenterExplorer.tsx
    ) {
        return;
    }

    return ContentElement ? (
        <ContentElement {...attribs}>{domToReact(children, options)}</ContentElement>
    ) : (
        <></>
    );
};

export default postContentBlock;
